import { useCallback, useState, useMemo } from 'react';
import moment from 'moment';

const startDateDefault = moment().subtract(1, 'day');
const endDateDefault = moment();

export const useDateRangePicker = (startDate = startDateDefault, endDate = endDateDefault) => {
  const [ dates, setDates ] = useState({
    startDate,
    endDate,
  });
  
  const [focusedInput, setFocusedInput] = useState(null);
  
  const onFocusChange = useCallback((nextFocusedInput) => {
    setFocusedInput(nextFocusedInput);
  }, []);
  
  const onDatesChange = useCallback((dates) => {
    setDates(dates);
  }, []);

  const existDates = useMemo(() => Boolean(dates.startDate) && Boolean(dates.endDate), [dates])

  const isOutsidePeriod = useMemo(() => {
    if (!existDates) return true;
    const startDateWithoutTime = moment(dates.startDate).startOf('day');
    const endDateWithoutTime = moment(dates.endDate).startOf('day');
    return endDateWithoutTime.diff(startDateWithoutTime, 'months') >= 1;
  }, [dates, existDates]);

  return {
    dates,
    existDates,
    isOutsidePeriod,
    focusedInput,
    onFocusChange,
    onDatesChange,
  }
};